// extracted by mini-css-extract-plugin
module.exports = {"disclaimerWrapper":"planRecommenderDisclaimer_disclaimerWrapper__SQGU7","disclaimerText":"planRecommenderDisclaimer_disclaimerText__3X_WJ"};